import { createTheme, ThemeProvider } from '@mui/material';
import { ToastProvider } from './components/ToastContext';
import { AppProvider } from './context/AppContext';
import { AppContent } from './context/AppContent';

import './App.css';

function App() {
  const theme = createTheme();

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <AppProvider>
          <AppContent />
        </AppProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
